








































import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
import {getCalculatorQuestions, get, getPdf, getCalculator} from '../../services/webclient/webclient';
import {translate} from "../../services/translation/translation";
import './_questions-page.less';
import $ from 'jquery';
import {goToTop} from "@/services/position/position";
import RadioGroup from '@/components/question-components/radio-group/radio-group.vue';
import numberSliderHightLightImages
    from "@/components/question-components/number-slider-hight-light-images/number-slider-hight-light-images.vue";
import numberSlider from "@/components/question-components/number-slider/number-slider.vue";
import numberSliderDynamicImages from "@/components/question-components/number-slider-dynamic-images/number-slider-dynamic-images.vue";
import colorPicker from "@/components/question-components/color-picker/color-picker.vue";
import checkboxGroup from "@/components/question-components/checkbox-group/checkbox-group.vue";
import progressbar from "@/components/progressbar/progressbar.vue";
import loader from "@/components/loader/loader.vue";

@Component({
    components: {
        RadioGroup,
        numberSliderHightLightImages,
        numberSlider,
        colorPicker,
        numberSliderDynamicImages,
        checkboxGroup,
        progressbar,
        loader,
    }
})

export default class QuestionsPage extends Vue {

    @Prop() selectedCalcId;
    @Prop() resetQuestionEngine;
    @Prop() selectedName;

    private data: any = {
        models: [],
        viewedQuestions: [],
        r: 0,
        progressbar: {
            'step0': 'active',
            'step1': '',
            'step2': '',
            'step3': ''
        }
    };
    private isLoaded = false;
    private isEnableNextButton = false;

    activated() {
        goToTop('questions-page', '');
        if(this.resetQuestionEngine){
            let self = this;
            this.data.models = [];
            this.data.viewedQuestions = [];
            this.isLoaded = false;
            getCalculatorQuestions(this.selectedCalcId).then(data => {
                // this.data.questions = data;
                this.data.models = data.map(function (t, i) {
                    return {type: self.getComponentName(t.type), id: t.id, value: '', componentSetting: t, next_question: '', isEnableNext: false};
                });
                this.initFirstQuestion();
                this.isLoaded = true;
            }).catch(err => console.warn(err));
        }else{
            if(this.data.viewedQuestions.length > 0 && this.data.viewedQuestions[this.data.viewedQuestions.length-1].next_question == 0){
                this.isEnableNextButton = true;
            }
        }
    }
    mounted() {
        let self = this;
        getCalculatorQuestions(this.selectedCalcId).then(data => {
            // this.data.questions = data;
            this.data.models = data.map(function (t, i) {
                return {type: self.getComponentName(t.type), id: t.id, value: '', componentSetting: t, next_question: '', isEnableNext: false,skipSettings: t.skipSettings};
            });
            this.initFirstQuestion();
            this.isLoaded = true;
        }).catch(err => console.warn(err));
    }

    getComponentName(name){
        let componentName :string='';
        switch(name){
            case 'radio_group':
                componentName = 'radio-group';
            break;
            case 'checkbox_group':
                componentName = 'checkbox-group';
            break;
            case 'number_slider_hight_light_images':
                componentName =  'number-slider-hight-light-images';
            break;
            case 'number_slider_dynamic_image':
                componentName =  'number-slider-dynamic-images';
            break;
            case 'number_slider':
                componentName =  'number-slider';
            break;
            case 'colorpicker':
                componentName =  'color-picker';
            break;

            default:
                componentName =  '';
        }
        return componentName;
    }
    trans(key) {
        return translate(key);
    }

    initFirstQuestion(){
        if (this.data.models.length>0){
            this.initViewedQuestion(this.data.models[0].id);
        }
    }

    initViewedQuestion(id){
        let question :object= {};
        let self = this;
        $.each(this.data.models, function (index, model) {
            if(model.id == id){
                $.each(model.componentSetting.items, function (i, item) {
                    if(typeof item.only != "undefined" && item.only.length>0){
                        item.isEnabled = false;
                        $.each(self.data.viewedQuestions, function (index, element) {
                            $.each(item.only, function (index, onlyAnswer) {
                                if(element.value_id == onlyAnswer){
                                    item.isEnabled = true;
                                    goToTop('', item.id);
                                }
                            })
                        });
                    }else{
                        item.isEnabled = true;
                        goToTop('', item.id);
                    }
                });
                question = model;
            }
        });
        if(!$.isEmptyObject(question)){
            //console.log(question);
            if((question as any).skipSettings !== true){
                this.data.viewedQuestions.push(question);
            }
            else{
                if((question as any).componentSetting.next_question == 0){
                    this.data.viewedQuestions[this.data.viewedQuestions.length-1].next_question = '0';
                    //self.onSelectedAnswer(self.data.viewedQuestions);
                }
                else{
                    this.initViewedQuestion((question as any).componentSetting.next_question)
                }
                
            }
            
        }

    }


    questionEngine(question){
        if(this.isUsedQuestion(question.id)){
            //volt használva  a kérdés
            if(this.isNextQuestionIsSetting(question.id)){
                //volt használva a kérdés és meg is volt válaszolva
                if(this.isNextQuestionChange(question.id, question.next_question, question)){
                    //változik a sorrned
                    let nextQuestionId = this.settingQuestionValueNameNextQuestion(question);
                    this.removeAfterQuestion(question.id);
                    this.initViewedQuestion(nextQuestionId);
                }else{
                    //nem változik a sorrend
                    let nextQuestionId = this.settingQuestionValueNameNextQuestion(question);
                    this.removeAfterQuestion(question.id);
                    this.initViewedQuestion(nextQuestionId);
                }

            }else{
                let nextQuestionId = this.settingQuestionValueNameNextQuestion(question);
                this.initViewedQuestion(nextQuestionId);
            }
        }else{
            //nem volt még használva a kérdés
            this.initViewedQuestion(question.id);
        }
    }

    isUsedQuestion(questionId){
        let used :boolean = false;
        $.each(this.data.viewedQuestions, function (index, question) {
            if(question.id == questionId){
                used = true;
            }
        });
        return used;
    }
    isNextQuestionIsSetting(questionId){
        let used :boolean = true;
        $.each(this.data.viewedQuestions, function (index, question) {
            if(question.id == questionId && question.next_question == ""){
                used = false;
            }
        });
        return used;
    }
    isNextQuestionChange(questionId, nextQuestionId, questionData){
        let used :boolean = false;
        $.each(this.data.viewedQuestions, function (index, question) {
            if(question.id == questionId && question.next_question != nextQuestionId){
                used = true;
            }
        });
        return used;
    }
    removeAfterQuestion(questionId){
        let self = this;
        let startIndex :number = -1;
        $.each(this.data.viewedQuestions, function (index, question) {
            if(question.id == questionId){
                startIndex = Number(index);
            }

        });

        if(startIndex != -1){
            let deletedQuestions = self.data.viewedQuestions.splice(startIndex+1, ( self.data.viewedQuestions.length-startIndex+1 ));
            $.each(deletedQuestions, function (i, deletedQuestion) {
                $.each(self.data.models, function (index, model) {
                    if(deletedQuestion.id == model.id){
                        model.value = "";
                        model.value_id = "";
                        model.next_question = "";
                        model.isEnableNext = false;
                    }
                })
            })
        }
    }
    removeAfterViewedOptions(questionId){
        let self = this;
        let startIndex :number = -1;
        $.each(this.data.viewedQuestions, function (index, question) {
            if(question.id == questionId){
                startIndex = Number(index);
            }

        });

        if(startIndex != -1){
            let deletedQuestions = self.data.viewedQuestions.splice(startIndex+1, ( self.data.viewedQuestions.length-startIndex+1 ));
            $.each(deletedQuestions, function (i, deletedQuestion) {
                $.each(self.data.models, function (index, model) {
                    if(deletedQuestion.id == model.id){
                        model.isEnableNext = false;
                    }
                })
            })
        }
    }
    settingQuestionValueNameNextQuestion(question){
        let self = this;
        let nextQuestionId = 0;
        $.each(this.data.viewedQuestions, function (index, q) {
            if(q.id == question.id){
                q.value = question.value;
                q.value_id = question.value_id;
                q.name = question.name;
                if(typeof question.alternatenext != "undefined"){
                    let prevQuestionAnswer = self.getPrevQuestionAnswer(index);
                    let answer = question.alternatenext[prevQuestionAnswer];
                    if(prevQuestionAnswer != null && answer!= undefined){
                        q.next_question = question.alternatenext[prevQuestionAnswer];
                        nextQuestionId = question.alternatenext[prevQuestionAnswer];
                    }else{
                        q.next_question = question.next_question;
                        nextQuestionId = question.next_question;
                    }
                }else{
                    q.next_question = question.next_question;
                    nextQuestionId = question.next_question;
                }

                q.isEnableNext = question.isEnableNext;
            }
        });
        return nextQuestionId;
    }

    reInitNextQuestion(){
        let initQuestionId = this.data.viewedQuestions[this.data.viewedQuestions.length-1].next_question;
        this.initViewedQuestion(initQuestionId);
    }

    getPrevQuestionAnswer(index){
        index = index-1;
        if(index >=0 && this.data.viewedQuestions.length >= index){
            return this.data.viewedQuestions[index].value_id;
        }else{
            return null;
        }
    }

    enableNextComponent(){
        let enableFirst = true;
        let self = this;

        if(this.isEnableNextButton){
            $.each(this.data.viewedQuestions, function (index, q) {
                if(enableFirst && q.isEnableNext == false && q.value!=''){
                    enableFirst = false;
                    q.isEnableNext = true;
                }
                if(q.next_question == '0'){
                    self.onSelectedAnswer(self.data.viewedQuestions);
                }
            });
            this.isEnableNextButton = false;
        }

    }


    @Watch("selectedQuestionValue", {immediate: true, deep: true})
    onSelectedQuestionValue(value) {
        if (!$.isEmptyObject(value)) {
            if(value.value != ""){
                this.isEnableNextButton = true;
            }
            this.data.r = this.data.r +1;
            this.questionEngine(value);
        }
    }

    @Emit("selectedAnswer")
    onSelectedAnswer(value) {
    }
    @Emit("backToCalcSelector")
    onBackToCalcSelector(value) {
    }
}

